<template>
   <v-container
      class="fill-height px-4 pb-4"
      fluid
    >
      <v-row
        no-gutters
        justify="center"
        dense
        class="mx-4 mt-0 mb-4"
      >
        <v-stepper v-model="e1">
          <v-stepper-header>
            <v-stepper-step :complete="e1 > 1" step="1" id="v-templateAssetdetails-step-0">Asset Details</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 2" step="2" id="v-templateAssetdetails-step-1">Attributes</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 3" step="3" id="v-templateAssetdetails-step-2">Asset Resources</v-stepper-step>
            <v-divider></v-divider>
            <div class="v-stepper__step v-stepper__step--inactive"  id="v-templateAssetdetails-step-3">
              <span class="v-stepper__step__step" style="background-color:#FFFFFF !important;">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn icon v-on:click="startTour()" >
                            <v-icon size="28px" color="#468748" v-on="on">mdi-help-circle</v-icon>
                        </v-btn>
                    </template>
                    <span>View Help</span>
                </v-tooltip>
              </span>
            </div>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card
                class="mb-12"
                flat
              >
                <v-card-title>
                  <span class="headline">Asset Details</span>
                </v-card-title>

                <v-form
                  ref="form"
                  lazy-validation
                >
                  <p>What would you like to do?</p>
                  <v-radio-group v-model="task" :mandatory="true">
                    <v-radio label="Add a single Asset" value="single-asset"></v-radio>
                    <!-- <v-radio label="Add multiple similar Assets" value="multiple-assets"></v-radio> -->
                  </v-radio-group>

                  <p v-if="task == 'single-asset'">A single asset will be created with the given attribute details.</p>
                  <p v-else-if="task == 'multiple-assets'">Multiple assets will be created with default names and the given attribute details, you will be redirected to the search page displaying these new items.</p>

                  <v-text-field
                    v-if="task == 'single-asset'"
                    v-model="name"
                    label="Asset Name*"
                    required
                    :rules="inputRules"
                  ></v-text-field>

                  <v-text-field
                    v-if="task == 'single-asset'"
                    v-model="identifier"
                    label="Asset Identifier*"
                    required
                    :rules="inputRules"
                  ></v-text-field>
                
                  <v-textarea
                    name="assetDescription"
                    v-model="description"
                    label="Asset Description"
                    auto-grow
                    rows="1"
                  ></v-textarea>
                
                  <v-select
                    :items="sectionHeaders"
                    :menu-props="{ maxHeight: '400' }"
                    v-model="selectedSection"
                    item-text="name"
                    item-value="id"
                    label="Which Section should the Asset be in?*"
                    required
                    :rules="inputRules"
                    id="v-templateAssetdetails-step-4"
                  ></v-select>

                  <v-select
                    :items="categoryHeaders"
                    :menu-props="{ maxHeight: '400' }"
                    v-if="section !== null || this.selectedSection !== null"
                    v-model="selectedCategory"
                    item-text="name"
                    item-value="id"
                    label="Which Category should the Asset be in?*"
                    required
                    :rules="inputRules"
                  ></v-select>

                  <v-checkbox 
                    v-if="section !== null || this.selectedSection !== null"
                    v-model="copyAttributesFromAsset" 
                    class="pb-2"
                    :label="'Copy attributes from another asset?'" 
                    dense
                    hide-details
                  ></v-checkbox>

                  <v-select
                    :items="assetsToCopyFrom"
                    :menu-props="{ maxHeight: '400' }"
                    v-if="this.copyAttributesFromAsset"
                    v-model="assetIdToCopy"
                    item-text="name"
                    item-value="id"
                    label="Select asset to copy*"
                    required
                    :rules="inputRules"
                  ></v-select>
                </v-form>
              </v-card>

              <v-row justify="center" class="mt-n4 mb-2">
                <v-btn
                  color="primary"
                  class="mr-4"
                  @click="createAsset()"
                  :loading="this.assetInCreation"
                  :disabled="this.assetInCreation"
                  id="v-templateAssetdetails-step-5"
                >
                  <v-icon 
                      v-if="this.assetInCreation" 
                      size="28" 
                      color="white" dark
                  >
                      mdi-loading mdi-spin
                  </v-icon>
                  <span v-else>Create Asset</span>
                </v-btn>
              </v-row>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-card flat class="ma-2 pa-0" min-width="200px"> 
                  <v-row class="ma-0" justify="end">
                      <v-col cols="auto">
                          <v-btn color="primary" @click="addAttribute()">Add Attribute</v-btn>
                      </v-col>
                  </v-row>
                  <v-container fluid v-if="this.asset !== null">
                      <v-row class="cardContent">
                          <v-col cols="6" v-for="(attribute, index) in asset.attributes" :key="attribute.id">
                          <attribute-field :showDelete=true allowNewItems v-on:RemoveAttribute="OnRemoveAttribute"  v-on:OnChanged="OnAttributeChanged" :attribute="attribute" :assetid="asset.assetListingid" > <!--:taxonomy="{taxo}" --> </attribute-field>
                          </v-col>
                      </v-row>
                  </v-container>
              </v-card>

              <v-row justify="center" class="mt-4 mb-2">
                <v-btn color="blue-grey lighten-5" @click="viewNewAsset()">Skip / View Asset</v-btn>
                <v-btn
                  color="primary"
                  class="mr-4"
                  @click="next()"
                >
                  <span>Continue</span>
                </v-btn>
              </v-row>
            </v-stepper-content>
            
            <v-stepper-content step="3">
              <v-card 
                class="mb-12"
                flat
              >
                  <v-card-title>
                      <span class="headline">Asset Resources</span>
                  </v-card-title>
                  <v-card-text>
                      <v-container>
                          <v-row>
                              <v-col cols="4" class="pa-1" justify="center" align="center">
                                  <v-card height="190px" class="justify-center">
                                      <v-img max-height="190px" contain :src='(this.files.length) ? this.files[0].thumb : ""'/>
                                  </v-card>
                              </v-col>
                              <v-col cols="8" class="pa-1" >
                                  <v-card
                                      class="upload"
                                      color="transparent"
                                      min-height="200px"
                                      flat
                                  >
                                      <v-simple-table v-if="this.files.length">
                                          <template v-slot:default>
                                              <thead>
                                                  <tr>
                                                      <th class="text-left">File Name</th>
                                                      <th class="text-left"></th>
                                                  </tr>
                                              </thead>
                                              <tbody>
                                                  <tr v-for="(file,index) in files" :key="file.id">
                                                      <td>{{ file.name }}</td>
                                                      <td>
                                                          <v-btn class="icon-btn" color="red" icon @click="files.splice(index,1)">
                                                              <v-icon>mdi-file-remove</v-icon>
                                                          </v-btn>
                                                      </td>
                                                  </tr>
                                              </tbody>
                                          </template>
                                      </v-simple-table>
                                      
                                      <v-container 
                                          class="fill-height pa-4"
                                          fluid
                                      > 
                                          <v-row justify="center" align="center">
                                              <v-btn max-width="220px">
                                                  <label for="file" class="btn btn-lg btn-primary" style="">
                                                      Drop or Select Files
                                                  </label>
                                              </v-btn>
                                          </v-row>
                                      </v-container>
                                  </v-card>
                              </v-col>
                          </v-row>
                      </v-container>
                  </v-card-text>
                  <v-card-actions>
                      <v-row justify="center" style="margin: 0px">
                        <v-btn color="blue-grey lighten-5" @click="viewNewAsset()">Skip / View Asset</v-btn>
                        <v-btn
                          color="primary"
                          class="mr-4"
                          :loading="this.uploadingResources"
                          :disabled="this.uploadingResources"
                          @click="uploadAssetResources()"
                        >
                          <v-icon 
                              v-if="$refs.upload && this.$refs.upload.uploading" 
                              size="28" 
                              color="white" dark
                          >
                              mdi-loading mdi-spin
                          </v-icon>
                          <span v-else>Upload Resources</span>
                        </v-btn>
                    </v-row>
                  </v-card-actions>
                  <file-upload
                      :multiple="true"
                      :drop="true"
                      :drop-directory="true"
                      :maximum="20"
                      accept="image/*"
                      @input-filter="inputFilter"
                      v-model="files"
                      ref="upload"
                      :headers="GetAuthHeaderObj()"
                  ></file-upload>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper> 
      </v-row> 
      
      <NewAttribute v-on:OnDialogClose="addAttributeDialog = false" v-bind:newAttributeDialog="this.addAttributeDialog" :key="dialogChange"></NewAttribute>

      <v-tour name="stepOneTour" :steps="this.stepOneSteps"></v-tour>
    </v-container>
</template>


<script>
import { mapActions } from 'vuex'
import { mapState } from 'vuex'
import { mapGetters } from 'vuex'

import FileUpload from 'vue-upload-component'
import NewAttribute from '../../attributes/NewAttribute'
import AttributeField from '../../attributes/AttributeField'


export default {
  name: 'AddUpdateAssetFromTemplate',
  components: {
    FileUpload,
    NewAttribute,
    AttributeField
  },
  props: {
  },
  computed:{
    ...mapState("assetxpstate", [
        "sectionHeaders",
        "categoryHeaders",
        "section",
        "asset"
    ])
  },
  mounted:  function () {
    this.GetSectionHeaders();
    this.selectedSection = this.section !== null ? this.section.id : null;
  },
  data () {
    return {
      e1: 1,
      dialogChange: 0,
      inputRules: [
        v => v !== null || 'This is a required field.',
        v => v !== '' || 'This is a required field.'
      ],
      addAttributeDialog: false,
      copyAttributesFromAsset: false,
      assetsToCopyFrom: [],
      assetIdToCopy: null,
      task: null,
      assetToCreate: {},
      identifier: '',
      name: '',
      description: '',
      category: null,
      assetInCreation: false,
      uploadingResources: false,
      file: {},
      files: [],
      selectedSection: null, 
      selectedCategory: null,
      attributes: [],
      attributeValues: [],
      stepOneSteps: [
        {
          target: '#v-templateAssetdetails-step-0',
          content: '<b>Step 1:</b> Enter the key asset details. <br> For example, name, identifier and category details.',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '#v-templateAssetdetails-step-1',
          content: '<b>Step 2:</b> Assign the key asset attributes and provide important asset information.',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '#v-templateAssetdetails-step-2',
          content: '<b>Step 3:</b> Upload asset images.',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '#v-templateAssetdetails-step-3',
          content: '<b>Help:</b> Use the help button at any time to view the help tour.',
          params: {
            placement: 'bottom'
          }
        },
        {
          target: '#v-templateAssetdetails-step-4',
          content: 'Select a Section to view the available Categories.',
          params: {
            placement: 'right'
          }
        },
        {
          target: '#v-templateAssetdetails-step-5',
          content: 'Once you have completed all of the above fields, continue to the next step.',
          params: {
            placement: 'right'
          }
        }
      ],
      stepTwoSteps: [
        {
          target: '#v-templateAtttributes-step-0',
          content: '<b>Step 1:</b> Enter the key asset details. <br> For example, name, identifier and category details.',
          params: {
            placement: 'bottom'
          }
        }
      ],
      stepThreeSteps: [
        {
          target: '#v-templateResources-step-0',
          content: '<b>Step 1:</b> Enter the key asset details. <br> For example, name, identifier and category details.',
          params: {
            placement: 'bottom'
          }
        }
      ]
    }
  },
  methods:{
    ...mapGetters("authentication", [
      "GetAuthHeaderObj"
    ]),
        ...mapActions("assetxpstate", [
        "GetSectionHeaders",
        "GetCategoryHeadersBySection",
        "CreateAsset",
        "GetSectionAttributes",
        "UploadResources",
        "UpdateAssetAttributeMulti",
        "UpdateAssetAttribute",
        "UpdateAssetAttributeAsset",
        "AddAttributeToAsset",
        "RemoveAttributeFromAsset",
        "GetSectionListings"
    ]),

    OnRemoveAttribute(attribute)
    {
        attribute.assetListingid = this.asset.assetListingid;
        this.RemoveAttributeFromAsset(attribute);
    },
    OnAttributeChanged(evt) {
    //Multi
        if(evt.attribute.attributeType == 0) {
            var multiArray = new Array();

            for (let i = 0; i < evt.values.length; i++) {
                multiArray.push(evt.values[i]);
            }

            this.UpdateAssetAttributeMulti({id : evt.attribute.id, multiChoiceItems : multiArray, attributeType : evt.attribute.attributeType, assetListingid : this.asset.assetListingid})
            .then( () => {
                this.LoadAsset();
            });
        }
        // STRING or NUMERIC
        else if(evt.attribute.attributeType == 1 || evt.attribute.attributeType == 2) {   
            this.UpdateAssetAttribute({id : evt.attribute.id, val : evt.values[0], attributeType : evt.attribute.attributeType, assetListingid : this.asset.assetListingid})
            .then( () => {
                this.LoadAsset();
            });
        }
        else if (evt.attribute.attributeType == 3) {
            this.UpdateAssetAttributeAsset({id : evt.attribute.id, items : evt.values, catFilters : evt.attribute.catFilters, sectionFilters : evt.attribute.sectionFilters, attributeType : evt.attribute.attributeType, assetListingid : this.asset.assetListingid});
        }
    },
    next () {
      if (this.$refs.form.validate()) {
        this.e1 = this.e1 + 1
      }
    },
    addAttribute() {
      this.dialogChange != 1;
      this.addAttributeDialog = true;
    },
    startTour () {
      if(this.e1 == 1)
      {
        this.$tours['stepOneTour'].start();
      }
      else if(this.e1 == 2)
      {
        this.$tours['stepTwoTour'].start();
      }
      else {
        this.$tours['stepThreeTour'].start(this.e1);
      }
    },
    attributeValueChanged(changeDetail) {
      var index = this.attributeValues.findIndex(a => a.id === changeDetail.id)

      if(index === -1) {
        this.attributeValues.push(changeDetail);
      } else {
        this.attributeValues[index] = changeDetail;
      }
    },   
    attributeSelected(changeDetail) {
      this.attributes.push(changeDetail);
    }, 
    async uploadAssetResources() { 
      this.uploadingResources = true;
      let formData = new window.FormData();
      formData.set('assetDetailid', this.asset.assetDetailid);

      for (var i = 0; i < this.$refs.upload.files.length; i++) {
        var file = this.$refs.upload.files[i];
        let value

        for (let key in file.data) {
          value = file.data[key]
          if (value && typeof value === 'object' && typeof value.toString !== 'function') {
            if (value instanceof File) {
              formData.append(key, value, value.name)
            } else {
              formData.append(key, JSON.stringify(value))
            }
          } else if (value !== null && value !== undefined) {
            formData.append(key, value)
          }
        }

        formData.append(this.name, file.file, file.file.filename || file.name)
      }

      await this.UploadResources(formData).then(() =>{
        this.viewNewAsset();
      });
    },
    createAsset() {
      if (this.$refs.form.validate()) {
        this.assetInCreation = true; 

        var newAsset = {
          identifier: this.identifier,
          name: this.name,
          sectionid : this.selectedSection,
          description: this.description, 
          categoryid: this.selectedCategory,
          attributes: this.attributeValues,
          copyAttributesFromAsset: this.copyAttributesFromAsset,
          copyAttributesFromALId: this.assetIdToCopy
        };

        this.CreateAsset(newAsset).then(() =>{
          this.assetInCreation = false; 
          this.e1 = this.e1 + 1;
        }).catch((error) => {
          console.error("[AddUpdateAsset] Failed to create asset", error);
          this.assetInCreation = false;
        });
      }   
    },
    viewNewAsset() { 
      this.$router.push({ name: 'Asset Detail', params: { assetDetailid: this.asset.assetDetailid }});
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
          // Before adding a file
          // Filter system files or hide files
          if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
              return prevent()
          }

          // Filter php html js file
          if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
              return prevent()
          }
      }

      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
          // Create a blob field
          newFile.blob = ''
          let URL = window.URL || window.webkitURL
          
          if (URL && URL.createObjectURL) {
              newFile.blob = URL.createObjectURL(newFile.file)
          }

          // Thumbnails
          newFile.thumb = ''
          
          if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
              newFile.thumb = newFile.blob
          }
      }
    }
  },
  watch: {
    selectedSection() {
      this.category = null;
      this.GetCategoryHeadersBySection(this.selectedSection);
      this.assetsToCopyFrom = null;
      /*
      this.GetSectionListings(this.selectedSection).then((response) =>{
        this.assetsToCopyFrom = response.data;
      });
      */
    }
  }
}
</script> 

<style>
.v-card__title {
  padding-left: 0 !important;
}
</style>